<div class="usan-form-item cas-registry-info-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ hasCasRegistryFile ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column-wrapped">
      <span class="required-star" *ngIf="isDocumentRequired">*</span>
      <span class="usan-form-item cas-registry-info-item cas-registry-info-text" [innerHTML]="title"></span>
      <div class="break"></div>
      <div class="cas-registry-info-text usan-form-item cas-registry-info-item" *ngIf="isFormCType">
        CAS Registry number must be supplied.  A copy of the CAS search results for your compound 
        should be submitted as an MS-Word document with your application. If there&apos;s multiple states of 
        hydration, multiple CAS numbers may be submitted but the name will be the same; please indicate 
        which state of hydration is the form to be marketed as that will be the one shown on the statement 
        of adoption.
      </div>
      <div class="cas-registry-info-text usan-form-item cas-registry-info-item" *ngIf="isFormAType || isFormDType">
        <ul class="cas-registry-info-text">
          <li>Letter from CAS showing the CAS registry number</li>
          <li>Electronic document (MS-Word and/or PDF document preferred) 
          showing results of a CAS search for the CAS registry number listed on the USAN application</li>
        </ul>
      </div>
      <div class="cas-registry-info-text usan-form-item cas-registry-info-item" *ngIf="isFormBType">
        <ul class="cas-registry-info-text">
          <li>Letter from CAS showing the CAS registry number</li>
          <li>Electronic document (MS-Word and/or PDF document preferred) 
          showing results of a CAS search for the CAS registry number listed on the USAN application</li>
          <li>Sequence and structural information should be UNMASKED in the CAS database</li>
        </ul>
      </div>
      <div class="cas-registry-info-text usan-form-item cas-registry-info-item" *ngIf="isFormEType">
        Disclose the formula, CAS number, and structure for the polymer. In addition, disclose the formulas, CAS 
        numbers, and structures for each monomer present.
      </div>
      <div class="cas-registry-info-text usan-form-item cas-registry-info-item" *ngIf="isFormFType">
        CAS Registry number must be supplied for the entire substance for proteins, gene therapies, and other 
        substance to which a CAS registry number can be assigned. If your substance is a cell therapy, or other 
        substance to which a CAS registry number cannot be assigned, please indicate that it "could not be 
        assigned." You will be asked to attach a letter from CAS or a copy of the CAS search results later in 
        the application process.
      </div>
    </div>
  </div>
  <div class="input-error" *ngIf="showRequiredError">
    This is a required document.
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-cas-registry-info form-btn form-btn-style form-btn-text" (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload CAS registry information
    </button>
  </div>
  <ng-container *ngIf="hasCasRegistryFile">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>

</div>